/**
 * La primera de varias copias del mismo nodo que de verdad se ve.
 *
 * Las filas del estimado se pintan DOS veces: tarjeta móvil dentro de un
 * `md:hidden` y renglón de escritorio dentro de un `hidden md:block`. Las dos
 * llevan el mismo `data-unpriced-item`, así que `document.querySelector`
 * devuelve siempre la móvil —la primera en orden de documento— y en escritorio
 * está en `display:none`. Sobre un nodo oculto, `scrollIntoView()` y `focus()`
 * no hacen nada, y el botón de "llévame a la siguiente partida sin precio"
 * parece roto aunque el selector sea correcto.
 *
 * El predicado entra por parámetro porque jsdom no calcula layout: ahí
 * `offsetParent` es null para TODO, así que una comprobación en línea no se
 * podría probar. Con el predicado fuera, la prueba pasa el suyo.
 *
 * ACTUALIZACIÓN: desde que `EstimateLineItems` pinta UNA sola tarjeta por
 * partida en todos los anchos, ya no hay copia oculta que esquivar y esta
 * función devuelve el único nodo. Se queda porque sigue siendo la red: el
 * `nodes[0]` de reserva es lo que salva el salto si algún día vuelve a haber
 * dos vistas de la misma fila.
 */
export function firstVisible<T extends HTMLElement>(
    nodes: T[],
    isVisible: (n: T) => boolean = n => n.offsetParent !== null,
): T | null {
    return nodes.find(isVisible) ?? nodes[0] ?? null;
}
